const MARCH_DATA_LAYER_NAME = 'marchDataLayer'

let isMarchGtmInjected = false

export function injectMarchOwnGtm(containerId: string): void {
  if (!containerId || isMarchGtmInjected) return
  try {
    window.marchDataLayer = window.marchDataLayer || []
    window.marchDataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    })

    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(
      containerId
    )}&l=${MARCH_DATA_LAYER_NAME}`
    document.head.appendChild(script)

    if (document.body) {
      const noscript = document.createElement('noscript')
      const iframe = document.createElement('iframe')
      iframe.src = `https://www.googletagmanager.com/ns.html?id=${encodeURIComponent(
        containerId
      )}`
      iframe.height = '0'
      iframe.width = '0'
      iframe.style.display = 'none'
      iframe.style.visibility = 'hidden'
      noscript.appendChild(iframe)
      document.body.appendChild(noscript)
    }

    isMarchGtmInjected = true
  } catch {
    // GTM injection error should not block app initialization
  }
}
